import React, { Component } from "react"
import PageTitle from "./Components/Layout/PageTitle"
import AveragePerformanceScoreDonut from "./Components/Widgets/Performance/AveragePerformanceScoreDonut"
import AverageEngagementScoreDonut from "./Components/Widgets/Performance/AverageEngagementScoreDonut"

class Dashboard1 extends Component {
  render() {
    return (
      <div>
        <PageTitle title="Dashboard 1" />
        <div className="row">
          <AveragePerformanceScoreDonut />
          <AverageEngagementScoreDonut />
          <div className="col-lg-4 col-md-5">
            <div className="card">
              <div className="card-block">
                <h3 className="card-title">Our Visitors</h3>
                <h6 className="card-subtitle">Different Devices Used to Visit</h6>
                <div id="visitor" style={{ height: "290px", width: "100%" }} />
              </div>
              <div>
                <hr className="m-t-0 m-b-0" />
              </div>
              <div className="card-block text-center ">
                <ul className="list-inline m-b-0">
                  <li>
                    <h6 className="text-muted text-info">Mobile</h6>
                  </li>
                  <li>
                    <h6 className="text-muted text-primary">Desktop</h6>
                  </li>
                  <li>
                    <h6 className="text-muted text-success">Tablet</h6>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default Dashboard1



// WEBPACK FOOTER //
// ./src/Dashboard1.js